export { default } from './SkeletonRectangle.js';
